import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(authenticated)/docs/")({
  beforeLoad: () => {
    // Redirect root /docs to /docs/en (default language)
    throw redirect({
      to: "/docs/$lang",
      params: { lang: "en" },
      replace: true,
    })
  },
})
